<template>
    <div class="p-4 bg-white dark:bg-gray-800 rounded-lg">

        <div v-if="todayNotifications.length > 0" class="space-y-4">
            <DashboardMessageBellNotification
                v-for="notification in todayNotifications"
                :key="notification.id"
                :notification="notification"
            />
        </div>

        <p v-else class="text-gray-500 dark:text-gray-400 text-sm">No notifications available.</p>
    </div>
</template>

<script>
import DashboardMessageBellNotification from './DashboardMessageBellNotification.vue'

export default {
    components: { DashboardMessageBellNotification },
    props: {
        todayNotifications: {
            type: Array,
            required: true,
        },
    },
}
</script>
